import { Box, Button, Typography } from "@mui/material";
import { ReactNode } from "react";

interface InsightsSectionProps {
  title: string;
  viewAllLabel?: string;
  onViewAll?: () => void;
  actionButton?: ReactNode;
  children: ReactNode;
}

export default function InsightsSection({
  title,
  viewAllLabel,
  onViewAll,
  actionButton,
  children,
}: InsightsSectionProps) {
  return (
    <Box
      sx={{
        backgroundColor: "white",
        marginBottom: "20px",
        px: 3,
        pt: 2,
        pb: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="body1" fontWeight="bold">
            {title}
          </Typography>
          {actionButton}
        </Box>
        {viewAllLabel && onViewAll && (
          <Button
            variant="text"
            onClick={onViewAll}
            sx={{ marginLeft: "auto" }}
          >
            {viewAllLabel}
          </Button>
        )}
      </Box>
      {children}
    </Box>
  );
}
